import { isPlatformBrowser } from "@angular/common";
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { Resolve, Router } from "@angular/router";
import { of } from "rxjs";
import { ApiService } from "src/app/services/api.service";
import { GlobalDataService } from "src/app/services/global-data.service";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class MoviesListingDataService implements Resolve<any> {
  constructor(
    private API: ApiService,
    private globalData: GlobalDataService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId
  ) {}

  resolve() {
    const initialMallData = this.globalData.getGlobalData();

    const nowShowing = initialMallData.nowShowing;

    if (initialMallData?.cinemaProvider?.moviesEnabled) {
      if (isPlatformBrowser(this.platformId) && !nowShowing) {
        this.API.GET(
          environment.cdn_url +
            "movies/" +
            (initialMallData?.cinemaProvider?.name === "Nu Metro"
              ? "moviesNuMetro.json"
              : "moviesSK.json")
        ).subscribe({
          next: (movies) => {
            if (movies.data.sessions) this.globalData.setMovieData(movies.data);

            return true;
          },
          error: () => {},
        });
      } else {
        return true;
      }
    } else {
      this.router.navigate(["/"]);
      return of(null);
    }
  }
}
